import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from '../../components/not-found/not-found.component';
import {AuthorComponent} from './components/author/author.component';

const routes: Routes = [
  {path: ':urlPath/:anyParams', component: AuthorComponent},
  {path: ':urlPath', component: AuthorComponent},
  {path: '**', component: NotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthorRoutingModule {}

export const authorRoutingComponents = [AuthorComponent];
